import React, { useState, useEffect } from 'react';

const AnimatedTitle = ({ text = "we make it happen.", specialWord = "happen." }) => {
  const [revealedWords, setRevealedWords] = useState([]);
  const [animationCycle, setAnimationCycle] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);

  const words = text.split(' ');

  // Lógica de revelado palabra por palabra
  useEffect(() => {
    if (isFadingOut) return;

    setRevealedWords([]);
    const revealNextWord = (index) => {
      if (index < words.length) {
        setTimeout(() => {
          setRevealedWords(prev => [...prev, index]);
          revealNextWord(index + 1);
        }, 200);
      }
    };
    revealNextWord(0);
  }, [animationCycle, words.length, isFadingOut]);

  // Lógica del ciclo infinito (10 segundos)
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFadingOut(true);
      setTimeout(() => {
        setRevealedWords([]);
        setIsFadingOut(false);
        setAnimationCycle(prev => prev + 1);
      }, 800); 
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <h1 className={`banner-title ${isFadingOut ? 'fade-out' : ''}`}>
      {words.map((word, index) => (
        <React.Fragment key={index}>
          <span
            className={`
              ${word === specialWord ? 'span-special' : ''} 
              ${revealedWords.includes(index) ? 'animate-in' : 'hidden'}
            `}
          >
            {word}
          </span>
          {index < words.length - 1 && ' '}
        </React.Fragment>
      ))}
    </h1>
  );
};

export default AnimatedTitle;